module.exports = __webpack_public_path__ + "static/media/1f33a.07302a0c.svg";